import { apiFetch } from '@/lib/api';
import type { Group } from '@domain/types';

export type GroupInput = {
  name: string;
  currency: string;
  color: string;
};

export type GroupSummary = {
  groupId: string;
  memberCount: number;
  expenseCount: number;
  totalSpentMinor: number;
  lastActivity: string | null;
};

export async function listGroups(includeArchived = false): Promise<Group[]> {
  return apiFetch<Group[]>(`/groups?includeArchived=${includeArchived}`);
}

export async function getGroup(id: string): Promise<Group | null> {
  try {
    return await apiFetch<Group>(`/groups/${id}`);
  } catch (error) {
    if ((error as Error).message.includes('404')) return null;
    throw error;
  }
}

export async function createGroup(input: GroupInput): Promise<Group> {
  return apiFetch<Group>('/groups', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updateGroup(
  id: string,
  patch: Partial<GroupInput & { archived: boolean }>
): Promise<void> {
  await apiFetch<void>(`/groups/${id}`, {
    method: 'PUT',
    body: JSON.stringify(patch),
  });
}

export async function deleteGroup(id: string): Promise<void> {
  await apiFetch<void>(`/groups/${id}`, {
    method: 'DELETE',
  });
}

export async function listGroupSummaries(): Promise<GroupSummary[]> {
  return apiFetch<GroupSummary[]>('/groups/summaries');
}
